import initialState from './initialState';

import {
  FETCH_CUSTOM_REPORTS_LIST_ADMIN,
  FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS,
  FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE,
  RESET_CUSTOM_REPORTS_PARAMS_ADMIN,
  RESET_CUSTOM_REPORT_TO_EDIT_ADMIN,
  HIDE_CUSTOM_REPORT_FORM_ADMIN,
  UPDATE_DISPLAY_FLAG_ADMIN,
  UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS,
  UPDATE_DISPLAY_FLAG_ADMIN_FAILURE,
  SAVE_CUSTOM_REPORT_ADMIN,
  SAVE_CUSTOM_REPORT_ADMIN_SUCCESS,
  SAVE_CUSTOM_REPORT_ADMIN_FAILURE,
  SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN,
  SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN,
  SELECT_CUSTOM_REPORT_ADMIN,
  DELETE_CUSTOM_REPORT_ADMIN,
  DELETE_CUSTOM_REPORT_ADMIN_SUCCESS,
  DELETE_CUSTOM_REPORT_ADMIN_FAILURE,
  DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN,
  TEST_CUSTOM_REPORT_ADMIN,
  TEST_CUSTOM_REPORT_ADMIN_SUCCESS,
  TEST_CUSTOM_REPORT_ADMIN_FAILURE,
  UPDATE_ROW_ID_TO_SCROLL_ADMIN,
  RESET_ROW_ID_TO_SCROLL_ADMIN,
  CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN,
  VERIFY_PARAM_TO_EDIT_ADMIN,
  VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS,
  VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE,
} from './types';

export default function customReportsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SELECT_CUSTOM_REPORT_ADMIN:
      return {
        ...state,
        customReportToEditId: action.customReportId,
      };
    case FETCH_CUSTOM_REPORTS_LIST_ADMIN:
      return {
        ...state,
        isFetchingCustomReports: true,
      };
    case FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS:
      return {
        ...state,
        isFetchingCustomReports: false,
        customReports: action.customReports,
      };
    case FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE:
      return {
        ...state,
        isFetchingCustomReports: false,
      };
    case SAVE_CUSTOM_REPORT_ADMIN:
      return {
        ...state,
        isSavingCustomReportQueryInProgress: true,
      };
    case SAVE_CUSTOM_REPORT_ADMIN_SUCCESS:
      return {
        ...state,
        readOnly: true,
        addedReportId: action.addedReportId,
        isSavingCustomReportQueryInProgress: false,
      };
    case SAVE_CUSTOM_REPORT_ADMIN_FAILURE:
      return {
        ...state,
        isSavingCustomReportQueryInProgress: false,
      };
    case DELETE_CUSTOM_REPORT_ADMIN:
      return {
        ...state,
        isDeletingInProgress: true,
      };
    case DELETE_CUSTOM_REPORT_ADMIN_SUCCESS:
    case DELETE_CUSTOM_REPORT_ADMIN_FAILURE:
      return {
        ...state,
        isDeletingInProgress: false,
      };
    case SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN:
      return {
        ...state,
        openFormForEdit: false,
        openFormForAdd: true,
        customReportToEditId: null,
        readOnly: false,
        isAddingReportSet: action.isAddingReportSet,
      };
    case HIDE_CUSTOM_REPORT_FORM_ADMIN:
      return {
        ...state,
        openFormForEdit: false,
        openFormForAdd: false,
        isAddingReportSet: false,
      };
    case SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN:
      return {
        ...state,
        openFormForEdit: true,
        openFormForAdd: false,
        isAddingReportSet: false,
        customReportToEditId: action.customReportToEditId,
        readOnly: action.readOnly,
      };
    case RESET_CUSTOM_REPORT_TO_EDIT_ADMIN:
      return {
        ...state,
        customReportToEditId: initialState.customReportToEditId,
      };
    case DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN:
      return {
        ...state,
        readOnly: false,
      };
    case TEST_CUSTOM_REPORT_ADMIN:
      return {
        ...state,
        isTestCustomReportQueryInProgress: true,
      };
    case TEST_CUSTOM_REPORT_ADMIN_SUCCESS:
      return {
        ...state,
        isTestCustomReportQueryInProgress: false,
        customReportData: action.response,
      };
    case TEST_CUSTOM_REPORT_ADMIN_FAILURE:
      return {
        ...state,
        isTestCustomReportQueryInProgress: false,
      };
    case CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN:
      return {
        ...state,
        customReportData: null,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS_ADMIN:
      return {
        ...state,
        isFetchingCustomReportParams: true,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS:
      return {
        ...state,
        customReportParams: action.params,
        isFetchingCustomReportParams: false,
      };
    case FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE:
      return {
        ...state,
        isFetchingCustomReportParams: false,
      };
    case RESET_CUSTOM_REPORTS_PARAMS_ADMIN:
      return {
        ...state,
        customReportParams: null,
        customReportParamsDropdownValues: null,
        customReportParamsQueryData: null,
      };
    case UPDATE_DISPLAY_FLAG_ADMIN:
      return {
        ...state,
        isFetchingCustomReport: true,
      };
    case UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS:
      return {
        ...state,
        customReports: state.customReports.map(report => {
          if (report.reportSetId === action.reportSetId) {
            return { ...report, customReportFlag: action.reportSetDisplayFlag };
          }
          return report;
        }),
        isFetchingCustomReport: false,
      };
    case UPDATE_DISPLAY_FLAG_ADMIN_FAILURE:
      return {
        ...state,
        isFetchingCustomReport: true,
      };
    case UPDATE_ROW_ID_TO_SCROLL_ADMIN:
      return {
        ...state,
        rowIndexToScrollTo: action.customReportId,
      };
    case RESET_ROW_ID_TO_SCROLL_ADMIN:
      return {
        ...state,
        rowIndexToScrollTo: null,
      };
    case VERIFY_PARAM_TO_EDIT_ADMIN:
      return {
        ...state,
        isVerifyingParamToEditQuery: true,
        reportParamToEditOptions: [],
      };
    case VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS:
      return {
        ...state,
        isVerifyingParamToEditQuery: false,
        reportParamToEditOptions: action.response,
      };
    case VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE:
      return {
        ...state,
        isVerifyingParamToEditQuery: false,
        reportParamToEditOptions: [],
      };
    default:
      return state;
  }
}
